import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { CopyToClipboard } from "react-copy-to-clipboard";
//Material imports
import Avatar from "@mui/material/Avatar";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import withStyles from "@mui/styles/withStyles";
import ListItemIcon from "@mui/material/ListItemIcon";
import OpenInNew from "@mui/icons-material/OpenInNew";
import Hidden from "@mui/material/Hidden";
//Limitless imports
import { useNotificationContext } from "@limitless/common/hooks";
import { useSettingsDrawer } from "@limitless/common/hooks/settings-drawer/SettingsDrawerHook";
import { withi18n } from "../../../../customer/components";
import { useExpertMessageContext, useExpertProfileContext } from "../../../../expert";
import IconMenu from "../../icon-menu/IconMenu";
import OkCancelDialog from "../../dialogs/ok-cancel-dialog/OkCancelDialog";
const ProfileHeaderItem = ({
  classes,
  t,
  handleSignOut,
  mode,
  portalList,
  crowdManagerPortal,
  onPortalClicked,
  renderSettingsDrawer,
  handleSettingsNavigation
}) => {
  const [openSignOutDialog, setOpenSignOutDialog] = React.useState(false);
  const {
    toggleSettingsDrawer
  } = useSettingsDrawer();
  const {
    message
  } = useExpertMessageContext();
  const {
    profile,
    getExpertName,
    getExpertRole
  } = useExpertProfileContext();
  const {
    addSuccessNotification
  } = useNotificationContext();
  const onSignOutClick = () => {
    handleSignOut();
  };
  const handleCloseDialog = () => {
    setOpenSignOutDialog(false);
  };
  const handleSignOutClick = () => {
    setOpenSignOutDialog(true);
  };
  const handleOpenMessage = () => {
    onPortalClicked(crowdManagerPortal, `find/${message.messageId}`);
  };
  const renderProfilePicture = () => {
    const {
      picture,
      email,
      firstName
    } = profile;
    const expertName = /*#__PURE__*/React.createElement("div", {
      className: classes.userNameRole
    }, /*#__PURE__*/React.createElement(Typography, {
      component: "div"
    }, getExpertName()), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      component: "div",
      style: {
        textTransform: "capitalize"
      }
    }, getExpertRole()));
    const name = /*#__PURE__*/React.createElement(Hidden, {
      lgDown: true
    }, expertName);
    if (picture) {
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Avatar, {
        className: classes.avatarPicture,
        alt: firstName ? firstName : "",
        src: `data:image/png;base64, ${picture}`,
        id: "profileHeaderPicture"
      }), name);
    }
    if (firstName) {
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Avatar, {
        className: classes.avatar,
        id: "profileHeaderPicture"
      }, firstName.charAt(0).toUpperCase()), name);
    }
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Avatar, {
      className: classes.avatar,
      id: "profileHeaderPicture"
    }, email ? email.charAt(0).toUpperCase() : ""), name);
  };
  const renderPortals = portalList => {
    return portalList.map(portal => {
      return /*#__PURE__*/React.createElement(MenuItem, {
        key: portal.portalName,
        className: classes.portalMenu,
        onClick: () => onPortalClicked(portal),
        id: portal.portalName
      }, t(`${portal.title}`), /*#__PURE__*/React.createElement(ListItemIcon, {
        className: classes.portalIcon
      }, /*#__PURE__*/React.createElement(OpenInNew, null)));
    });
  };
  const getDialog = () => {
    const dialogs = [];
    dialogs.push(/*#__PURE__*/React.createElement(OkCancelDialog, {
      key: 0,
      open: openSignOutDialog,
      title: "Sign Out",
      onOKClick: onSignOutClick,
      okLabel: "Confirm",
      okId: "confirmSignOutButton",
      onCancelClick: handleCloseDialog,
      cancelId: "cancelSignOutButton"
    }, /*#__PURE__*/React.createElement(Typography, {
      color: "textPrimary",
      id: "alert-dialog-title"
    }, t("Are you sure you want to Sign Out?"))));
    if (renderSettingsDrawer) {
      dialogs.push(renderSettingsDrawer());
    }
    return dialogs;
  };
  const handleSettingsClick = () => {
    if (renderSettingsDrawer) {
      toggleSettingsDrawer();
    } else {
      handleSettingsNavigation();
    }
  };
  const showEditProfile = mode === "expert" ? true : false;
  return /*#__PURE__*/React.createElement(IconMenu, {
    id: "profileHeaderMenuButton",
    tooltip: "Change your profile & sign out",
    ariaLabel: "Profile",
    icon: renderProfilePicture(),
    iconColor: "primaryContrast",
    placement: "bottom-end",
    dialogs: getDialog()
  }, portalList.length > 0 && renderPortals(portalList), crowdManagerPortal && /*#__PURE__*/React.createElement(MenuItem, {
    className: classes.portalMenu,
    onClick: handleOpenMessage,
    id: "profileHeaderMenuOpenMessage",
    disabled: message.messageId ? false : true
  }, t("Open Message"), /*#__PURE__*/React.createElement(ListItemIcon, {
    className: classes.portalIcon
  }, /*#__PURE__*/React.createElement(OpenInNew, null))), showEditProfile && /*#__PURE__*/React.createElement(CopyToClipboard, {
    text: profile.userName,
    onCopy: () => {
      addSuccessNotification(t("User Name copied to clipboard"));
    }
  }, /*#__PURE__*/React.createElement(MenuItem, {
    id: "copyUserName"
  }, t("Copy User Name"))), /*#__PURE__*/React.createElement(MenuItem, {
    onClick: handleSettingsClick,
    id: "profileHeaderMenuSettings"
  }, t("Settings")), /*#__PURE__*/React.createElement(MenuItem, {
    onClick: handleSignOutClick,
    id: "profileHeaderMenuSignOut"
  }, t("Sign Out")));
};
const styles = {
  popperClose: {
    pointerEvents: "none",
    top: "2px !important"
  },
  popperOpen: {
    top: "2px !important"
  },
  avatar: {
    height: 30,
    width: 30,
    pointerEvents: "none"
  },
  avatarPicture: {
    height: 35,
    width: 35,
    pointerEvents: "none"
  },
  portalMenu: {
    justifyContent: "space-between"
  },
  portalIcon: {
    marginRight: 0,
    marginLeft: 20
  },
  userNameRole: {
    marginLeft: 8
  }
};
export default withStyles(styles)(withi18n(ProfileHeaderItem));
ProfileHeaderItem.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  handleSignOut: PropTypes.func.isRequired,
  handleSettingsDrawer: PropTypes.func,
  mode: PropTypes.string.isRequired,
  portalList: PropTypes.array.isRequired,
  onPortalClicked: PropTypes.func.isRequired,
  renderSettingsDrawer: PropTypes.func,
  crowdManagerPortal: PropTypes.object,
  handleSettingsNavigation: PropTypes.func
};